var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMainLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 138.282,
    height: 30.417,
    viewBox: "0 0 138.282 30.417",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_146_",
    transform: "translate(-60 -17.1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_196_",
    transform: "translate(150.78 17.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_199_",
    d: "M549.877,30.452a3.163,3.163,0,0,0-.595-1.292L540.257,18.7l-.062-.062a3.976,3.976,0,0,0-3.159-1.538H506.6a3.992,3.992,0,0,0-4,4V43.518a3.992,3.992,0,0,0,4,4h30.438a4.037,4.037,0,0,0,3.159-1.538l.062-.062,9-10.46a4.813,4.813,0,0,0,.841-3.1A7.849,7.849,0,0,0,549.877,30.452Z",
    transform: "translate(-502.6 -17.1)",
    fill: "#e51b26"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_163_",
    transform: "translate(60 18.925)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_191_",
    transform: "translate(0 7.363)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_192_",
    d: "M73.147,73.365a1.477,1.477,0,0,1-.41,1.026,6.409,6.409,0,0,1-2.359,1.62,7.446,7.446,0,0,1-2.995.656,7.384,7.384,0,1,1,0-14.768,7.349,7.349,0,0,1,4.779,1.6,1.4,1.4,0,0,1,.492,1.108,1.318,1.318,0,0,1-.287.8,1.262,1.262,0,0,1-1.026.513,1.4,1.4,0,0,1-.861-.287,4.969,4.969,0,0,0-3.056-1.005,3.938,3.938,0,0,0-3.1,1.354,5.121,5.121,0,0,0,0,6.563,3.938,3.938,0,0,0,3.1,1.354,5.27,5.27,0,0,0,3.61-1.477,1.271,1.271,0,0,1,.841-.328,1.36,1.36,0,0,1,1.005.41A1.582,1.582,0,0,1,73.147,73.365Z",
    transform: "translate(-60 -61.9)",
    fill: "#736e6d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_188_",
    transform: "translate(15.732 7.363)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_189_",
    d: "M145.807,62.331a1.347,1.347,0,0,1,.41.985,1.429,1.429,0,0,1-.41,1.005,1.272,1.272,0,0,1-.984.41,5.6,5.6,0,0,0-3.507,1.108,3.627,3.627,0,0,0-1.456,3.056v6.092a1.579,1.579,0,0,1-3.159,0V63.623a1.5,1.5,0,0,1,.451-1.108,1.475,1.475,0,0,1,1.087-.472,1.6,1.6,0,0,1,1.128.472,1.465,1.465,0,0,1,.492,1.108V64.3a5.76,5.76,0,0,1,2.133-1.846,6.572,6.572,0,0,1,2.83-.554A1.452,1.452,0,0,1,145.807,62.331Z",
    transform: "translate(-136.7 -61.9)",
    fill: "#736e6d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_184_",
    transform: "translate(25.433 7.404)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_185_",
    d: "M198.337,69.4a.9.9,0,0,1-.328.738,1.248,1.248,0,0,1-.82.287h-9.948a3.891,3.891,0,0,0,1.313,2.707,4.151,4.151,0,0,0,2.913,1.067,5.927,5.927,0,0,0,4.184-1.764,1.07,1.07,0,0,1,.779-.287,1.235,1.235,0,0,1,1.026.513,1.3,1.3,0,0,1,.267.738,1.356,1.356,0,0,1-.451,1.026,7.393,7.393,0,0,1-2.625,1.764,8.651,8.651,0,0,1-3.261.656A7.353,7.353,0,0,1,184,69.463a7.1,7.1,0,0,1,2.113-5.23,6.965,6.965,0,0,1,5.169-2.133,6.792,6.792,0,0,1,5.066,2.092A7.266,7.266,0,0,1,198.337,69.4Zm-3.138-1.19a4.094,4.094,0,0,0-1.313-2.5,3.792,3.792,0,0,0-2.666-.985,3.919,3.919,0,0,0-2.666.943,4.3,4.3,0,0,0-1.313,2.523H195.2Z",
    transform: "translate(-184 -62.1)",
    fill: "#736e6d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_175_",
    transform: "translate(41.206 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_176_",
    d: "M275.668,46.429a1.579,1.579,0,0,1-3.159,0V45.69a4.7,4.7,0,0,1-1.887,1.8,5.706,5.706,0,0,1-2.728.656,6.608,6.608,0,0,1-5.025-2.092,7.415,7.415,0,0,1-1.969-5.292,7.49,7.49,0,0,1,1.949-5.292,6.622,6.622,0,0,1,5.046-2.092,5.626,5.626,0,0,1,2.748.677,4.477,4.477,0,0,1,1.846,1.8V27.559a1.52,1.52,0,0,1,.472-1.108,1.585,1.585,0,0,1,2.215,0,1.52,1.52,0,0,1,.472,1.108v18.87Zm-4.307-2.379a5.191,5.191,0,0,0,0-6.563,3.908,3.908,0,0,0-3.056-1.292,3.857,3.857,0,0,0-3.056,1.313,5.133,5.133,0,0,0,0,6.522,3.857,3.857,0,0,0,3.056,1.313A3.908,3.908,0,0,0,271.36,44.049Z",
    transform: "translate(-260.9 -26)",
    fill: "#736e6d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_169_",
    transform: "translate(58.435 7.404)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_170_",
    d: "M359.237,69.4a.9.9,0,0,1-.328.738,1.248,1.248,0,0,1-.82.287h-9.948a3.891,3.891,0,0,0,1.313,2.707,4.151,4.151,0,0,0,2.913,1.067,5.927,5.927,0,0,0,4.184-1.764,1.07,1.07,0,0,1,.779-.287,1.235,1.235,0,0,1,1.026.513,1.3,1.3,0,0,1,.267.738,1.356,1.356,0,0,1-.451,1.026,7.392,7.392,0,0,1-2.625,1.764,8.651,8.651,0,0,1-3.261.656,7.353,7.353,0,0,1-7.384-7.384,7.1,7.1,0,0,1,2.113-5.23,6.965,6.965,0,0,1,5.169-2.133,6.792,6.792,0,0,1,5.066,2.092A7.266,7.266,0,0,1,359.237,69.4Zm-3.138-1.19a4.094,4.094,0,0,0-1.313-2.5,3.792,3.792,0,0,0-2.666-.985,3.919,3.919,0,0,0-2.666.943,4.3,4.3,0,0,0-1.313,2.523H356.1Z",
    transform: "translate(-344.9 -62.1)",
    fill: "#736e6d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_164_",
    transform: "translate(74.084 7.507)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_166_",
    d: "M432.953,75.727a1.361,1.361,0,0,1-.513,1.108,1.283,1.283,0,0,1-.861.287,1.231,1.231,0,0,1-1.087-.554L427.066,72.1l-3.4,4.471a1.38,1.38,0,0,1-1.949.267,1.361,1.361,0,0,1-.513-1.108,1.4,1.4,0,0,1,.287-.861l3.876-5.066-3.794-4.964a1.3,1.3,0,0,1-.287-.841,1.29,1.29,0,0,1,.554-1.108,1.536,1.536,0,0,1,.841-.287,1.231,1.231,0,0,1,1.087.554l3.343,4.348,3.282-4.348a1.254,1.254,0,0,1,1.087-.554,1.45,1.45,0,0,1,.841.246,1.32,1.32,0,0,1,.574,1.128,1.435,1.435,0,0,1-.287.841l-3.774,4.964,3.876,5.066A1.538,1.538,0,0,1,432.953,75.727Z",
    transform: "translate(-421.2 -62.6)",
    fill: "#736e6d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_158_",
    transform: "translate(166.306 27.027)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_160_",
    d: "M581.377,67.038a1.411,1.411,0,0,1-.451,1.067,1.5,1.5,0,0,1-1.087.451,1.425,1.425,0,0,1-1.087-.451,1.49,1.49,0,0,1-.451-1.067,1.425,1.425,0,0,1,.451-1.087,1.537,1.537,0,0,1,1.087-.451,1.488,1.488,0,0,1,1.087.451A1.456,1.456,0,0,1,581.377,67.038Z",
    transform: "translate(-578.3 -65.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_154_",
    transform: "translate(166.306 34.267)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_155_",
    d: "M581.377,102.338a1.411,1.411,0,0,1-.451,1.067,1.5,1.5,0,0,1-1.087.451,1.425,1.425,0,0,1-1.087-.451,1.489,1.489,0,0,1-.451-1.067,1.425,1.425,0,0,1,.451-1.087,1.537,1.537,0,0,1,1.087-.451,1.488,1.488,0,0,1,1.087.451A1.425,1.425,0,0,1,581.377,102.338Z",
    transform: "translate(-578.3 -100.8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_150_",
    transform: "translate(171.496 22.556)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_151_",
    d: "M608.748,53.463a16.2,16.2,0,0,1-2.974,9.209,1.19,1.19,0,0,1-1.005.554,1.071,1.071,0,0,1-.779-.328,1.059,1.059,0,0,1-.349-.779,1.664,1.664,0,0,1,.185-.595,18.323,18.323,0,0,0,2.277-8.061,17.746,17.746,0,0,0-2.318-8.061,1.664,1.664,0,0,1-.185-.595,1.094,1.094,0,0,1,.349-.779,1.163,1.163,0,0,1,.82-.328,1.182,1.182,0,0,1,.984.554,15.07,15.07,0,0,1,2.195,4.369A14.786,14.786,0,0,1,608.748,53.463Z",
    transform: "translate(-603.6 -43.7)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_147_",
    transform: "translate(191.104 30.616)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_148_",
    d: "M702.523,84.661A1.661,1.661,0,1,1,700.861,83,1.654,1.654,0,0,1,702.523,84.661Z",
    transform: "translate(-699.2 -83)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainLogo);
export default __webpack_public_path__ + "static/media/main-logo.d883e131a3e316093860bdf62d13d5f9.svg";
export { ForwardRef as ReactComponent };